import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Container, CircularProgress, Alert } from "@mui/material";
import { DepartmentForm } from "../../components/Department/DepartmentForm";
import { departmentService } from "../../services/departmentService";

export const InvEditDepartment = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [department, setDepartment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        setLoading(true);
        const response = await departmentService.getDepartment(id);
        const responseData = response.data?.data || response.data;
        const departmentData = responseData?.department || responseData;
        setDepartment(departmentData);
      } catch (err) {
        setError("Failed to load department. Please try again.");
        console.error("Error fetching department:", err);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchDepartment();
    }
  }, [id]);

  if (loading) {
    return (
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="xl">
        <Box sx={{ py: 4 }}>
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        </Box>
      </Container>
    );
  }

  return (
    <Box
          sx={{
            minHeight: '100vh',
            background: 'linear-gradient(180deg, #f9fafc 0%, #f2f5f8 100%)',
          }}
        >
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        {department && <DepartmentForm mode="edit" initialData={department} />}
      </Box>
    </Container>
    </Box>
  );
};
